module.exports = __webpack_public_path__ + "img/Silueta-Funda2.637cdd75.png";